export default {"src":"/_next/static/media/residential9.3065ad64.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};